/**
 * How the stock screens write dates. Two kinds, kept apart on purpose: a
 * calendar day (`YYYY-MM-DD`, the day stock arrived or went out -- what the
 * person typed, with no time zone to shift it) and a moment (seconds, when a
 * row was written).
 */

/** "2026-09-08" as "8 Sept 2026", or whatever this browser's locale writes. Parsed as local noon, so no zone moves the day. */
export function calendarDay(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return new Date(y, m - 1, d, 12).toLocaleDateString(undefined, { dateStyle: "medium" });
}

export const when = (seconds: number): string =>
  new Date(seconds * 1000).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
